"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPostMailAllowedForCountry = void 0;
const country_1 = require("../enums/country");
const isPostMailAllowedForCountry = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.isPostMailAllowedForCountry = isPostMailAllowedForCountry;
